import React from 'react';

interface NodeLabelProps {
  children: React.ReactNode;
}

export const NodeLabel: React.FC<NodeLabelProps> = ({ children }) => {
  return <span style={{ flex: '1' }}>{children}</span>;
};
